/**
 * Created by Ivan on 13.02.2025
 */

const StickersRewardWindow = CleverappsWindow.extend({
    ctor: function () {
        this.stickers = cleverapps.stickersBook.newStickers;
        cleverapps.stickersBook.newStickers = undefined;

        this._super();
    },

    onWindowLoaded: function () {
        this._super({
            name: "StickersRewardWindow",
            content: this.getContent(),
            noBackground: true,
            closeButton: false
        });
    },

    getContent: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();

        const content = this.content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize(sceneSize.width * 0.9, sceneSize.height * 0.65);

        this.createStickersLayout();
        this.createStickersSource();

        return content;
    },

    createStickersLayout: function () {
        const styles = cleverapps.styles.StickersRewardWindow.stickers;

        const stickersViews = this.stickersViews = this.stickers.map((sticker) => new RewardStickerView(sticker));

        const stickersLayout = this.stickersLayout = new cleverapps.WrapGridLayout(stickersViews, {
            columns: this.calcColumnsCount(stickersViews.length),
            margin: styles.margin,
            fitToBox: this.content.getContentSize(),
            padding: styles.padding
        });
        stickersLayout.setAnchorPoint(0.5, 0.5);
        this.content.addChild(stickersLayout);
        stickersLayout.setAlignment(styles);

        stickersViews.forEach((sticker) => {
            if (sticker.stickerView) {
                sticker.stickerView.baseScale = stickersLayout.getScale();
            }
        });
    },

    createStickersSource: function () {
        const styles = cleverapps.styles.StickersRewardWindow.source;

        const stickersSource = this.stickersSource = new StickersPackView(bundles.stickers_reward_window.jsons.sticker_pack_json, this.stickers.length);
        this.content.addChild(stickersSource);

        const position = styles.initPosition || styles;

        stickersSource.setAlignment(position);
    },

    calcColumnsCount: function (stickersAmount) {
        if (cleverapps.config.type === "merge") {
            if (stickersAmount <= 4) {
                return 2;
            } if (stickersAmount <= 5) {
                return 3;
            } if (stickersAmount <= 15) {
                return 5;
            }

            if ([cleverapps.WideMode.HORIZONTAL, cleverapps.WideMode.SQUARE].includes(cleverapps.resolution.mode)) {
                return 8;
            }

            return 6;
        }

        if (stickersAmount <= 3) {
            return stickersAmount;
        }

        if (stickersAmount === 4) {
            return 2;
        }

        if (stickersAmount === 6) {
            return 3;
        }

        if (cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL) {
            return 5;
        }

        if (cleverapps.resolution.mode === cleverapps.WideMode.SQUARE) {
            return 4;
        }

        return 3;
    },

    getReceiveDuration: function () {
        return 0.9;
    },

    createReceiveAnimation: function () {
        const delays = PseudoRandom.GET().shuffle(this.stickersViews.map((sticker, index) => index));

        return new cc.Spawn(
            new cc.CallFunc(() => {
                this.stickersViews.forEach((sticker, index) => {
                    sticker.receiveStickerAnimation(delays[index] * 0.1, sticker);
                });
            }),
            new cc.DelayTime(this.stickersViews.length * 0.1 + this.getReceiveDuration())
        );
    },

    createCollectAnimation: function (callback) {
        return new cc.Sequence(
            new cc.CallFunc(() => {
                callback = cleverapps.wait(this.stickersViews.length, callback);

                this.stickersViews.forEach((stickerView) => {
                    stickerView.collectStickerAnimation(callback);
                });
            })
        );
    },

    onShow: function () {
        this._super();

        const tapToSkip = this.tapToSkip = new TapToSkip({
            text: Messages.get("TapToSkip"),
            onSkip: this.onSkip.bind(this)
        });
        tapToSkip.setAlignment(cleverapps.styles.TapToSkip);
        tapToSkip.show();
        this.addChild(tapToSkip);

        this.runAnimation();
    },

    runAnimation: function () {
        this.stickersSource.showAnimation(() => {
            this.runAction(new cc.Sequence(
                this.createReceiveAnimation(),
                new cc.CallFunc(() => {
                    if (this.tapToSkip) {
                        this.tapToSkip.hide();
                        delete this.tapToSkip;
                    }
                }),
                new cc.DelayTime(1.5),
                new cc.CallFunc(() => {
                    this.stickersViews.forEach((stickerView) => stickerView.finishReceiveAnimation());
                    this.createTapToCollect();
                })
            ));
        });
    },

    onSkip: function () {
        if (!this.tapToSkip) {
            return;
        }

        delete this.tapToSkip;

        this.stopAllActions();
        this.stickersSource.stopAllActions();
        this.stickersSource.setVisible(false);

        this.stickersViews.forEach((stickerView) => stickerView.finishReceiveAnimation());

        this.createSkipAnimation();
        this.createTapToCollect();
    },

    createSkipAnimation: function () {
        const flash = new cleverapps.Spine(bundles.stickers_reward_window.jsons.flash_json);
        flash.setCompleteListenerRemove();

        this.content.addChild(flash);

        flash.setAlignment(cleverapps.styles.StickersRewardWindow.flash);

        flash.setAnimation(0, "animation", false);
    },

    createTapToCollect: function () {
        if (this.tapToCollect) {
            return;
        }

        const tapToCollect = this.tapToCollect = new TapToSkip({
            text: Messages.get("Window.TapToContinue"),
            onSkip: () => {
                cleverapps.effects.fire("ui.button.haptic");
                cleverapps.shadow.hide();

                this.runAction(this.createCollectAnimation(this.close.bind(this)));
                this.tapToCollect = undefined;
            }
        });
        tapToCollect.setAlignment(cleverapps.styles.TapToSkip);
        tapToCollect.show();
        this.addChild(tapToCollect);
    },

    popUpAnimation: function () {},

    listBundles: function () {
        return cleverapps.unique(["stickers_reward_window"].concat(this.stickers.map((sticker) => StickersCollection.getCollectionBundle(sticker.collection.index, sticker.collection.season))));
    }
});

cleverapps.styles.StickersRewardWindow = {
    stickers: {
        x: { align: "center" },
        y: { align: "center" },

        margin: {
            x: 40,
            y: 40
        },

        padding: {
            top: 20,
            bottom: 20
        }
    },

    source: {
        x: { align: "center" },
        y: { align: "bottom" }
    },

    flash: {
        x: { align: "center" },
        y: { align: "center" }
    }
};

StickersRewardWindow.MAX_STICKERS_ON_SCREEN = 5;